import portalCommunication from '@3plearning/mathletics-portal-communication-service';


export const FOOTER_BUTTONS_SETUP = 'FOOTER_BUTTONS_SETUP';
export const FOOTER_BUTTON_CLICK = 'FOOTER_BUTTON_CLICK';


export function setupButtons(leftButtons, rightButtons) {
    return {
        type: FOOTER_BUTTONS_SETUP,
        payload: {
            leftButtons,
            rightButtons
        }
    };
}

export function buttonClick(buttonData) {
    if (buttonData.type === 'OPEN_URL') {
        portalCommunication.requestLoadingSpinner(true);
    }
    return {
        type: FOOTER_BUTTON_CLICK,
        payload: {
            ...buttonData
        }
    };
}



// WEBPACK FOOTER //
// ./components/page-footer/page-footer-actions.js